<template>
  <div>
    <div class="modal-body">
      <div class="modal-body-right">
        <ul class="tree">
          <li
            class="section"
            v-for="item in treeData"
            :value="item.id"
            :key="item.id"
          >
            <div v-if="item.checked" class="section-item">
              <div
                class="section-inner noselect"
                v-on:click="toggleTree(item.id)"
              >
                <input type="checkbox" class="marker" :id="'p' + item.id" />
                <label for="groupA">{{ item.name }}</label>
              </div>
              <div class="section-tailer">
                <input
                  type="checkbox"
                  class="checker-r"
                  name="rGroup"
                  :value="item.id"
                  :id="'delete' + item.id"
                  :checked="item.checked"
                  v-on:change="deleteCheckbox"
                />
                <label class="checkbox-r" :for="'delete' + item.id"></label>
              </div>
            </div>
            <ul :class="'delete' + item.id">
              <li
                v-for="child in item.children"
                :value="child.id"
                :key="child.id"
              >
                <div v-if="child.checked" class="section-item">
                  <div class="section-inner">
                    <img class="avatar" v-if="child.photoUrl !== null && child.photoUrl !== ''" :src="child.photoUrl" alt="" />
                    <img class="avatar" v-else src="@/assets/head_photo.png" alt="" />
                    <label>{{ child.name }}</label>
                  </div>
                  <div class="section-tailer">
                    <input
                      type="checkbox"
                      class="checker-r"
                      name="rGroup"
                      :value="child.id"
                      :checked="child.checked"
                      :id="'child' + child.id"
                      v-on:change="deleteCheckbox"
                    />
                    <label class="checkbox-r" :for="'child' + child.id"></label>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BTreeDel",
  props: {
    treeData: Array,
  },
  data() {
    return {};
  },
  methods: {
    toggleTree(event) {
      // 控制子集的展示与隐藏
      const tid = "p" + event;
      const id = "delete" + event;
      if (document.getElementById(tid).checked == true) {
        document.getElementById(tid).checked = false;
      } else {
        document.getElementById(tid).checked = true;
      }
      if (document.getElementById(tid).checked) {
        document.getElementsByClassName(id)[0].style.display = "block";
      } else {
        document.getElementsByClassName(id)[0].style.display = "none";
      }
    },
    deleteCheckbox(event) {
      const elementId = event.target.id;
      const value = event.target.value;
      const checkValue = event.target.checked;

      // checkbox值改变时 将list中对应的isChecked值改变
      if (String(elementId).indexOf("delete") != -1) {
        // 该父级ischecked
        for (var i = 0; i < this.treeData.length; i++) {
          if (this.treeData[i].id == value) {
            this.treeData[i].checked = checkValue;
          }
        }
        // 子集全选反选
        for (var q = 0; q < this.treeData.length; q++) {
          for (var w = 0; w < this.treeData[q].children.length; w++) {
            if (this.treeData[q].id == value) {
              this.treeData[q].children[w].checked = checkValue;
            }
          }
        }
      } else if (String(elementId).indexOf("child") != -1) {
        // 该子级ischecked
        for (var j = 0; j < this.treeData.length; j++) {
          for (var k = 0; k < this.treeData[j].children.length; k++) {
            if (this.treeData[j].children[k].id == value) {
              this.treeData[j].children[k].checked = checkValue;
            }
          }
        }
        // 子集取消全部 父级取消
        for (var r = 0; r < this.treeData.length; r++) {
          for (var t = 0; t < this.treeData[r].children.length; t++) {
            if (this.treeData[r].children[t].checked == false) {
              this.treeData[r].checked = false;
              break;
            }
          }
        }
        // 子集选中一个 父级选中
        for (var f = 0; f < this.treeData.length; f++) {
          for (var g = 0; g < this.treeData[f].children.length; g++) {
            if (this.treeData[f].children[g].checked == true) {
              this.treeData[f].checked = true;
              break;
            }
          }
        }
      }
      // 将已选中的 父级 子集 值拿到返回
      var array = [];
      for (var a = 0; a < this.treeData.length; a++) {
        if (this.treeData[a].checked == true) {
          var studentCheckedList = [];
          var checkedObject = {};
          checkedObject.classId = this.treeData[a].id;
          for (var c = 0; c < this.treeData[a].children.length; c++) {
            if (this.treeData[a].children[c].checked == true) {
              studentCheckedList.push(this.treeData[a].children[c].id);
            }
          }
          checkedObject.studentCheckedList = studentCheckedList;
          array.push(checkedObject);
        }
      }
      var obj = {};
      obj.array = array;
      obj.treeData = this.treeData;
      console.log(array);
      this.$emit("clickCheckbox", obj);
    },
  },
};
</script>

<style scoped>
.tree {
  background: white;
  list-style: none;
  padding-left: 15px;
  margin: 0;
  height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.section ul {
  display: none;
  list-style: none;
  padding: 0;
  margin: 0;
  /* transition: opacity 0.5s ease-out; */
  overflow: hidden;
}

/*.section-inner input:checked > div ul {
    display: block;
    opacity: 1;
    height: auto;
  } */

.section-inner input[type="checkbox"] {
  display: none;
}

.section {
  position: relative;
  justify-content: space-between;
}

.section label {
  margin-left: 20px;
}

.section .marker + label:before {
  content: url("../assets/tree-arrow.png");
  zoom: 0.5;
  -ms-zoom: 0.5;
  -webkit-zoom: 0.5;
  -moz-transform: scale(0.5,0.5);
  position: absolute;
  top: 26px;
  left: -25px;
  text-align: center;
  font-size: 30px;
  color: #f00;
  transition: all 0.5s;
}

.section .section-inner input:checked ~ label:before {
  color: #23c37a;
  transform: rotate(90deg);
}

.avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
}

.section-inner {
  display: flex;
  align-items: center;
  padding: 10px;
}

.checkbox {
  width: 22px;
  height: 22px;
  background: #ffffff;
  border: 1px solid #0171a3;
  border-radius: 2px;
}

.checker,
.checker-r {
  padding-left: 0;
  display: none;
}

.section-tailer {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.checker-r:checked + label {
  display: flex;
  align-items: center;
  justify-content: center;
}

.checker-r:checked + label::before {
  font-family: "Material Design Icons";
  content: "\f156";
  color: red;
  font-size: 1.5em;
}

.section-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.section-item:hover {
  background-color: #f5f5f5;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}
</style>